module.exports = __webpack_public_path__ + "static/media/check.5065c605.svg";